<template>
    <div id="page" :class="{
        closed: isClosed || !$store.state.is_horizontal,
    }" @click="start()">
        <div class="page" :class="{
            'vertical-page': !$store.state.is_horizontal,
        }">
            <section-container
                ref="section"
                :book="book"
                @scrolled="scrolled($event)"></section-container>
        </div>
        <sidebar
            :sections="sections"
            :book="book"
            :articles="articles"
            @reloadBook="loadBook()"
            @toggle="toggle"
            @toggleHondana="toggleHondana"
            @showLayout="$emit('showLayout')"
            @startReadingTracker="startReadingTracker"></sidebar>
        <procedure :value="scrollValue"></procedure>
        <add-hondana
            :book="book"
            @saved="loadBook()"></add-hondana>
    </div>
</template>

<style scoped lang="scss">
#page {
    margin-top: -42px;
    padding-right: 350px;
    min-height: 100dvh;
    transition: 0.2s ease;
    &.closed {
        padding-right: 0px;
    }
    .page {
        padding: 10px 50px;
        background-color: transparent;
        &.vertical-page {
            height: 100dvh;
            max-height: 100dvh;
        }
    }
}
@media screen and (max-width: 1340px) {
    #page {
        padding-right: 0px;
    }
}
@media screen and (max-width: 770px) {
    #page {
        padding-right: 0px;
        .page {
            padding: 0;
        }
    }
}
</style>

<script>
import sidebar from "./sidebar";
import procedure from "components/Procedure";
import sectionContainer from "./section";
import addHondana from "../addHondana";
export default {
    components: {
        sidebar,
        procedure,
        sectionContainer,
        addHondana
    },
    data() {
        return {
            sections: [],
            book: {},
            isClosed: false,
            scrollValue: 0,
            articles: [],
        }
    },
    methods: {
        load() {
            this.loadSections();
            this.loadBook();
            this.loadArticles();
        },
        loadSections() {
            axios.get("/author/book/sections/get", {params: {book_id: this.$route.params.book_id}}).then(res => {
                this.sections = res.data;
            }).catch(err => {
                if (err?.response?.status == 404) {
                    alert.err("指定のエピソードは存在しないか、公開が停止されています。");
                    this.$router.push("/");
                } else {
                    alert.err(err);
                }
            });
        },
        loadBook() {
            // 本
            axios.get("/author/book/get", {params: {book_id: this.$route.params.book_id}}).then(res => {
                this.book = res.data;
            }).catch(err => {
                if (err?.response?.status == 404) {
                    alert.err("指定の小説は存在しないか、公開が停止されています。");
                    this.$router.push("/");
                } else if (err?.response?.status == 403) {
                    alert.err(err);
                    this.$router.push("/");
                } else {
                    alert.err(err);
                }
            });
        },
        loadArticles() {
            axios.get("/author/articles/book", {params: {id: this.$route.params.book_id}}).then(res => {
                this.articles = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        toggle(is_closed) {
            this.isClosed = is_closed;
        },
        start() {
            try {
                $("#sectionPane").focus();
                if (this.$refs?.section?.$refs?.sectionBody) {
                    this.$refs.section.$refs.sectionBody.start();
                }
            } catch (error) {
                console.error(error);
            }
        },
        startReadingTracker() {
            try {
                this.$refs.section.$refs.sectionBody.startReadingTracker();
            } catch (error) {
                console.error(error);
            }
        },
        scrolled(ev) {
            if (isNaN(ev)) {
                this.scrollValue = 0;
            } else {
                this.scrollValue = ev;
            }
        },
        toggleHondana() {
            if (this.book.hondana_id) {
                // 本棚から外す
                axios.post("/mypage/genre/books/add", {
                    genre_id: this.book.hondana_id,
                    book_id: this.book.id
                }).then(res => {
                    alert.msg(res.data);
                    this.loadBook();
                }).catch(err => { alert.err(err.response); });
            } else {
                $("#add-hondana").modal("show");
            }
        },
    },
    mounted() {
        this.load();
    },
    beforeRouteLeave(to, from, next) {
        try {
            if (this.$refs.section && this.$refs.section.$refs.sectionBody) {
                this.$refs.section.$refs.sectionBody.abortEpisode();
            }
        } catch (error) {
            console.error(error);
        }
        next();
    },
    beforeRouteUpdate(n, o, next) {
        try {
            if (this.$refs.section && this.$refs.section.$refs.sectionBody) {
                this.$refs.section.$refs.sectionBody.abortEpisode();
            }
        } catch (error) {
            console.error(error);
        }
        next();
    }
}
</script>